module.exports = __webpack_public_path__ + "static/media/listview.ed0bd402.svg";